import { Toaster } from "sonner";
import { ArrowLeft } from "lucide-react";
import { EnquiryDetail } from "./EnquiryDetail";
import { InboxHeader } from "./InboxHeader";
import { InboxList } from "./InboxList";
import { useEnquiryInbox } from "./useEnquiryInbox";

export default function AdminInbox() {
  const inbox = useEnquiryInbox();
  return (
    <div data-testid="admin-inbox" className="min-h-screen bg-[#F3EFEA]">
      <Toaster position="top-center" richColors />
      <InboxHeader onRefresh={inbox.load} onLogout={inbox.logout} />
      <main className="mx-auto max-w-7xl px-5 py-8 grid gap-6 lg:grid-cols-12">
        <InboxList inbox={inbox} />
        <section className={`min-w-0 lg:col-span-7 ${inbox.current ? "" : "hidden lg:block"}`}>
          {inbox.current ? <>
            <button data-testid="admin-back-btn" onClick={() => inbox.setSelected(null)} className="lg:hidden mb-4 inline-flex items-center gap-2 text-sm text-[#0F5A47]"><ArrowLeft className="h-4 w-4" />All enquiries</button>
            <EnquiryDetail e={inbox.current} onStatus={inbox.setStatus} onDelete={inbox.remove} />
          </> : <div data-testid="admin-select-enquiry-prompt" className="h-full min-h-[20rem] rounded-3xl border border-dashed border-[#0F5A47]/25 grid place-items-center text-sm text-[#52635B]">Select an enquiry to read it</div>}
        </section>
      </main>
    </div>
  );
}